import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class AreaAPI {
  
  static list = (success, failure, logout) => {
    fetch(Config.app.link + 'api/area', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static get = (id, success, failure, logout) => {
    fetch(Config.app.link + 'api/area/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static save = (product, success, failure, logout) => {
    fetch(Config.app.link + 'api/area', new Header('POST', product))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure, logout) => {
    fetch(Config.app.link + 'api/area/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }
}
export default AreaAPI;